import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Auth components
import Login from "components/auth/Login";
import Signup from "components/auth/Signup";
import BirthDataSetup from "components/auth/BirthDataSetup";
// Main app components
import Dashboard from "pages/dashboard";
import MeetSomeoneNew from "pages/meet-someone-new";
import AstrologicalAudioPlayer from "pages/astrological-audio-player";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter basename="/astrotone">
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Auth routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/birth-data-setup" element={<BirthDataSetup />} />
        
        {/* Main app routes */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/meet-someone-new" element={<MeetSomeoneNew />} />
        <Route path="/astrological-audio-player" element={<AstrologicalAudioPlayer />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;